import { getTeamsBackgroundState } from "./trackTeamsBackgroundState";

export default function (callback: (isVisible: boolean) => void, targetWindow?: Window): ReturnType<Window["requestAnimationFrame"]> | undefined {
    const scope = targetWindow ?? self;
    // requestAnimationFrame won't get called if the page is not visible. So let's make sure the page is
    // currently visible. If not, then let's end the action here as there is no render time
    if (isPageVisible()) {
        /* eslint-disable-next-line no-restricted-properties -- (https://aka.ms/OWALintWiki)
         * This is intended as this is the wrapper everyone should be using */
        return scope.requestAnimationFrame(function endActionWithTime() {
            callback(true);
        });
    }
    else {
        // If the page is not visible, we should call the callback within a new task
        setTimeout(() => {
            callback(false);
        }, 0);
        return undefined;
    }
}

// Checks if the current environment is a hosted calendar based on the URL path.
// This util allows for paths that contain routing hints, e.g. /hosted/PUID@TID/calendar
// This is copied from owa-config to avoid circular dependency issues
function isHostedCalendar(): boolean {
    // `window` does not exist in a Web Worker. The DOM lib types `self.window` as always defined,
    // so this optional chain type-checks as `string[]` while short-circuiting to `undefined` at
    // runtime off the main thread. Default to an empty array rather than dereferencing undefined.
    const pathSegments = self.window?.location?.pathname?.split("/").filter(segment => segment.length > 0) ?? [];
    
    if (pathSegments.length > 2 && pathSegments[0] === "hosted" && pathSegments[2] === "calendar") {
        return true;
    }
    else if (pathSegments.length > 1 &&
        pathSegments[0] === "hosted" &&
        pathSegments[1] === "calendar") {
        return true;
    }
    else {
        return false;
    }
}

// TODO: Remove this code as it's overly endpoint-specific for this package
// https://outlookweb.visualstudio.com/Time%20and%20Places/_workitems/edit/391542
function isPageVisible(): boolean {
    // Check if the page is visible in OWA, Monarch and Teams client respectively
    // Calendar app running as an iframe in Teams client, get the app cached state to determine if the app is visible
    return isHostedCalendar()
        ? !getTeamsBackgroundState()
        : self.document?.visibilityState === "visible";
}
